"use client";

import { SubscribeToCommunicationCenter } from "@/components/common/subscribe-to-communication-center/subscribe-to-communication-center";
import { trans } from "@/service/i18n/i18n";
import { useRouter } from "@bprogress/next";
import { logEvent } from "@/service/logs/log";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { DownloadIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SuperLink as Link } from "@/components/common/super-link";

export const EbookActionWithSubscriptionList = ({
  state,
  close,
  isOpen,
}: {
  state: SubscriptionListState;
  close: () => void;
  isOpen: boolean;
}) => {
  const router = useRouter();
  const download = state.options?.download;
  const subscriptionInfo = state.options?.subscriptionInfo;
  const { logView } = useContext(ResourceContext);

  function onSuccess() {
    if (download) {
      if (window.fbq) {
        window.fbq("trackCustom", "EbookDownload");
      }
      window.dataLayer?.push({ event: "ebook_download" } as never);

      logEvent("ebook_download_click", logView, {});

      setTimeout(() => {
        window.location = download;
      }, 10);
    } else {
      router.refresh();
    }
  }

  return (
    <SubscribeToCommunicationCenter
      state={state}
      onSuccess={onSuccess}
      subscriptionInfo={subscriptionInfo}
      Action={
        <>
          {download ? (
            <>
              <DownloadIcon className="h-4 w-4" /> Pobierz i subskrybuj
            </>
          ) : (
            <>{trans("subscription_list.form.confirm")}</>
          )}
        </>
      }
      ActionSubscribed={
        <>
          {download && (
            <>
              <Button asChild={true}>
                <Link
                  href={download}
                  onClick={() => {
                    logEvent("ebook_download_click", logView, {});
                  }}
                >
                  <DownloadIcon />
                  Pobierz e-booka
                </Link>
              </Button>
            </>
          )}
        </>
      }
      close={close}
      isOpen={isOpen}
    />
  );
};
